import { Check, X } from 'lucide-react';
import { signOut } from 'firebase/auth';

import { auth } from '@/shared';
import { Button } from '@/shared/ui/shadcn/button';

import { ApplicationTimeline, type TimelineEvent } from './_shared/ApplicationTimeline';

const EVENTS: readonly TimelineEvent[] = [
  { icon: Check, label: 'Application Submitted' },
  { icon: Check, label: 'Application Reviewed' },
  { icon: X, label: 'Application Not Accepted' },
];

export function ApplicationRejectedStep() {
  return (
    <div className="flex w-full flex-col gap-6">
      <ApplicationTimeline events={EVENTS} />
      <Button
        type="button"
        variant="secondary"
        radius="pill"
        size="lg"
        className="w-full"
        onClick={() => void signOut(auth)}
      >
        Sign out
      </Button>
    </div>
  );
}
